import ConfirmReturnContainer from './ConfirmReturnContainer';

export default ConfirmReturnContainer;
